export var ZIndexes;
(function (ZIndexes) {
  ZIndexes.Nav = 1;
  /**
   * @deprecated Do not use
   */
  ZIndexes.ScrollablePane = 1;
  ZIndexes.FocusStyle = 1;
  ZIndexes.Coachmark = 1000;
  ZIndexes.Layer = 1000000;
  ZIndexes.KeytipLayer = 1000001;
})(ZIndexes || (ZIndexes = {}));